import { render } from "./About.vue?vue&type=template&id=06edfc6c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=06edfc6c&scoped=true&lang=css"

import exportComponent from "/Users/admin/Work/AUM 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06edfc6c"]])

export default __exports__